<template>
  <div>
  	<div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-shuffle"></i>
        <div class="mg-l-20">
          <h4>{{$t("transfer.海外转运管理")}}
          </h4>
        </div>
      </div>
      <div class="tx-right">
        <a v-if="check_arr.length > 0" href="javascript:;" class="btn btn-primary" @click="exportOrder('1')">{{$t("transfer.导出选中的订单")}}</a>
      	<a v-if="check_arr.length == 0" href="javascript:;" class="btn"  :class="active ? 'btn-primary':'btn-outline-secondary'" @click="exportOrder('2')">{{$t("transfer.导出符合条件的订单")}}</a>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
    	<div class="clear-key">
	        <a v-show="_status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
	          {{$t("transfer.状态：")}}
	          <span class="mg-r-10">{{$t($dict.transferAboardStatus[_status])}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="track_code" href="javascript:;" class=" mg-r-15" @click="clearKey('trackCode')">
	          {{$t("transfer.物流单号：")}}
	          <span class="mg-r-10">{{track_code}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="weight_geq" href="javascript:;" class=" mg-r-15" @click="clearKey('weightGeq')">
	          {{$t("transfer.包裹起始重：")}}
	          <span class="mg-r-10">{{weight_geq}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="weight_leq" href="javascript:;" class=" mg-r-15" @click="clearKey('weightLeq')">
	          {{$t("transfer.包裹截止重：")}}
	          <span class="mg-r-10">{{weight_leq}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="transfer_code" href="javascript:;" class=" mg-r-15" @click="clearKey('transferCode')">
	          {{$t("transfer.转运单号：")}}
	          <span class="mg-r-10">{{transfer_code}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="logistics" href="javascript:;" class=" mg-r-15" @click="clearKey('logistics')">
	          {{$t("transfer.物流：")}}
	          <span class="mg-r-10">{{logistics}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	        <a v-show="distributor_name" href="javascript:;" class=" mg-r-15" @click="clearKey('distributor')">
	          {{$t("transfer.客户：")}}
	          <span class="mg-r-10">{{distributor_name}}</span>
	          <i class="fa fa-close"></i>
	        </a>
	      </div>
    </div>  
  </div>  
</template>

<script>
export default {
  props: ['_status','track_code','weight_geq','weight_leq','transfer_code','logistics','distributor_name','check_arr'],
  data(){
    return {
    }
  },  
  computed: {
    active() {
      return this.track_code || this.weight_geq || this.weight_leq || this.transfer_code || this.logistics || this.distributor_name
        ? true
        : false;
    }
  },
  methods: {
  	clearKey(type){
      this.$emit('clearKey', type)
    },
    exportOrder(type){
    	this.$emit("exportOrder", type, this.active);
    }
  }
}
</script>

<style lang="less" scoped>
.br-pagetitle i.fa{
  color: #17A2B8;
  font-size: 70px;
}
</style>

